import { ErrorBanner } from './ErrorBanner';
import { FileUploadCard } from '../../shared/FileUploadCard';
import { LinkInputForm } from './LinkInputForm';
import {
  clearLinksModalMessages,
  fetchComments,
  fetchCreateComment,
  fetchDeleteComment,
  fetchEditComment
} from './commentSlice';
import { useToastProvider } from '../../shared/ToastProvider';
import { useEffect, useState } from 'react';
import { getEnvVar } from '../../utils/getEnvVar';
import {
  COMMENTS_TITLE,
  PHASE_NAME_VALUE_MAP
} from '../../shared/AppConstants';
import { useDispatch, useSelector } from 'react-redux';
import { useStatusMessages } from '../../shared/StatusMessages';
import { useAPIProgress } from '../../shared/APIProgress';
import { EntityLinksList } from '../../shared/EntityLinksList';
import { setActiveSection } from '../Strategy/strategySlice';
import { Divider, Grid } from '@mui/material';

export function StrategyComments({ userInfoMap }) {
  const dispatch = useDispatch();
  const activeSection = useSelector((state) => state.strategy.activeSection);
  const comments = useSelector((state) => state.comments.comments);
  const { enqueueToast } = useToastProvider();
  const createErrorMessage = useSelector(
    (state) => state.comments.createErrorMessage
  );
  const strategyNumber = useSelector((state) => state.phases.strategyNumber);
  const [entityToDelete, setEntityToDelete] = useState(null);
  const { incrementAPIInProgress, decrementAPIInProgress } = useAPIProgress();
  const {
    setStatusErrorMsg,
    setStatusInfoMsg,
    clearAllMessages,
    setStatusSuccessMsg
  } = useStatusMessages();
  const commonProps = {
    setStatusErrorMsg,
    incrementAPIInProgress,
    decrementAPIInProgress,
    setStatusInfoMsg,
    clearAllMessages,
    setStatusSuccessMsg
  };

  const handleModalEditConfirm = (comment) => {
    return dispatch(fetchEditComment(comment));
  };

  const handleModalDeleteConfirm = () => {
    dispatch(fetchDeleteComment(entityToDelete.commentId)).then((response) => {
      if (response.type === 'comments/delete/fulfilled') {
        enqueueToast({
          variant: 'success',
          message: 'Comment deleted successfully'
        });
      }
    });
  };

  const onSave = (data, _, clearComponent) => {
    dispatch(
      fetchCreateComment({
        comment: data.formValues.comment,
        visibleOnSummary: true,
        ...data.selectedPhases.reduce((result, phase) => {
          result[PHASE_NAME_VALUE_MAP[phase]] = true;
          return result;
        }, {})
      })
    ).then((response) => {
      if (response.type === 'comments/create/fulfilled') {
        clearComponent();
        enqueueToast({
          variant: 'success',
          message: 'Comment created successfully'
        });
      }
    });
  };

  useEffect(() => {
    if (strategyNumber) dispatch(fetchComments());
  }, [strategyNumber]);

  useEffect(() => {
    if (activeSection === COMMENTS_TITLE) {
      document.getElementById('commentsSection')?.scrollIntoView();
      dispatch(setActiveSection(null));
    }
  }, [activeSection]);

  return (
    <section id="commentsSection">
      <Grid mt={4}>
        <ErrorBanner errorMessage={createErrorMessage} />
        <FileUploadCard
          title={`${COMMENTS_TITLE}s`}
          entity={'comment'}
          VariableForm={LinkInputForm}
          variableFormProps={{ minRows: 3, name: 'comment' }}
          onSave={onSave}
          commonProps={{
            clearAllMessages: () => dispatch(clearLinksModalMessages())
          }}
          hideDescription={true}
          count={comments ? Object.keys(comments).length : 0}
          additionalContent={
            <>
              {comments && Object.values(comments).length > 0 && (
                <Divider style={{ marginTop: '1em' }} />
              )}
              <EntityLinksList
                key={COMMENTS_TITLE}
                entityName={COMMENTS_TITLE}
                entityData={Object.values(comments)}
                apiUrl={`${getEnvVar('VITE_DMSM_API_URL')}/comments`}
                userInfoMap={userInfoMap}
                commonProps={commonProps}
                isEdit={true}
                dispatch={dispatch}
                showHideEnabled={true}
                handleEntityUpdateLogic={handleModalEditConfirm}
                deleteHandler={handleModalDeleteConfirm}
                setEntityToDelete={setEntityToDelete}
              />
            </>
          }
        />
      </Grid>
    </section>
  );
}
